/**
 * Created by jszh on 2020/6/12.
 */


'use strict';

import {smart} from "./address_parse";

const SmartAddress = {
    smart,
};

export default SmartAddress;
